import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

interface CreateTicketData {
  type: 'request' | 'suggestion' | 'compliment' | 'complaint' | 'report';
  subject: string;
  description: string;
  attachments?: string[];
}

export const useCreateTicket = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateTicketData) => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error('Usuário não autenticado');

      const { data: ticket, error } = await supabase
        .from('support_tickets')
        .insert([{
          user_id: user.id,
          type: data.type,
          subject: data.subject,
          description: data.description,
          attachments: data.attachments || [] as any,
          ticket_number: null as any, // Will be auto-generated by trigger
        }])
        .select()
        .single();

      if (error) throw error;
      return ticket;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['support-tickets'] });
      toast.success('Ticket criado com sucesso!');
    },
    onError: (error) => {
      console.error('Erro ao criar ticket:', error);
      toast.error('Erro ao criar ticket. Tente novamente.');
    },
  });
};
